import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import SystemLogGrid from './systemLogGrid';
import './systemLog.css';
//Imports the axios instance to make API calls
import API from '../../services/api';

import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications'

function Log() {

    const { t } = useTranslation('common');
    /*Saves the input values in the state*/
    const [from_date, setFromDate] = useState('')
    const [to_date, setToDate] = useState('')
    /**This works for ONE category. The selected one*/
    const [category, setCategory] = useState('0')
    /**This works with the list that comes in de API*/
    const [categories, setCategories] = useState([]);
    /**This works for ONE category. The selected one*/
    const [event, setEvent] = useState('0')
    /**This works with the list that comes in de API*/
    const [events, setEvents] = useState([])
    // Used to disable the dropdowns when is loading the data
    const [loading, setLoading] = useState(true);
    // Used to save the list og logs
    const [logResults, setLogResults] = useState([]);

    /*Function called in Search button. Returns the data and populates the Grid*/
    const searchLog = async () => {
        try {

            if (to_date === '' || from_date === '') {
                Notifications.notify(t('log.dates_required'), ERROR_NOTIFICATION);
                return;
            }

            setLogResults([]);

            const url = `/SysLog?initialDate=${from_date ? from_date : 0}&finalDate=${to_date ? to_date : 0}&categoryName=${category}&eventTypeName=${event}`;
            const response = await API.get(url);

            if (response.data.code !== 100) {
                Notifications.notify(response.data.code, ERROR_NOTIFICATION)
                return;
            }
            if (response.data.data) {
                setLogResults(response.data.data);
            }

        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    };

    /** We use useEffect to connect with de API and map the data into the SELECT (dropdown) elements*/
    useEffect(() => {
        async function getDropdownsData() {
            /**Call to API to get the categories list */
            const catList = await API.get(`/SysLog/syslogCategories`);
            /**Call to API to get the events list */
            const evtList = await API.get(`/SysLog/syslogEventTypes`);
            /*Map the categories to get each categorie. This allows us to use categories in the select elements*/
            setCategories(catList.data.data);
            setCategory(catList.data.data[0].value);
            /*Map the events to get each categorie. This allows us to use categories in the select elements*/
            setEvents(evtList.data.data);
            setEvent(evtList.data.data[0].value);
            /**Disables the dropdowns when the data is loading*/
            setLoading(false);
        }
        getDropdownsData();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps



    return (
        <div className="container-fluid container_log mt-3">
            <div className="row row_attrs">
                <div className="col-md-2 justify-content-center container_filters_log">
                    {/*Form*/}
                    <div className="form-group">
                        <label htmlFor="log_date_from" className="label_log ilo_lbl_general">{t('log.date_from')}</label>
                        <input type="date" onChange={(e) => { setFromDate(e.target.value) }} value={from_date} className="form-control log_inputs" id="log_date_from" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="log_date_to" className="label_log ilo_lbl_general">{t('log.date_to')}</label>
                        <input type="date" onChange={(e) => { setToDate(e.target.value) }} value={to_date} className="form-control log_inputs" id="log_date_to" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="log_category" className="label_log ilo_lbl_general">{t('log.category')}</label>
                        <select disabled={loading} onChange={(e) => { setCategory(e.target.value) }} className="form-control log_inputs" id="log_category">
                            {categories.map((categorie) => {
                                return (
                                    <option key={categorie.id} value={categorie.value}>
                                        {t(`log.category_${categorie.value}`)}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="log_event" className="label_log ilo_lbl_general">{t('log.event')}</label>
                        <select disabled={loading} onChange={(e) => { setEvent(e.target.value) }} className="form-control log_inputs" id="log_event">
                            {events.map((event) => {
                                return (
                                    <option key={event.id} value={event.value}>
                                        {t(`log.event_${event.value}`)}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="form-group text-right">
                        <button type="button" onClick={searchLog} className="btn btn-primary ilo-btn">{t('log.btn_search')}</button>
                    </div>
                </div>
                <div className="col-md-10">
                    <div className="row">
                        <div className="container_grid">
                            <SystemLogGrid data={logResults ? logResults : []} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Log